import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import { RenderOn } from '../../RenderOn/RenderOn';
import type { PlayerPortalsPageProps } from './types';

import styles from './PlayerPortalsPage.module.scss';

export const PlayerPortalsPageSubHeader = ({
  subheader,
}: Pick<PlayerPortalsPageProps, 'subheader'>) => {
  return (
    <RenderOn condition={subheader?.length > 0}>
      <section className={styles['subheader']} data-testid={'page-subheader'}>
        {subheader?.map(x => (
          <AsyncComponent
            kontentItem={x}
            contentType={x.system.type as ConfiguredComponents}
            key={x.system.id}
          />
        ))}
      </section>
    </RenderOn>
  );
};
